import React from "react";
import ReactExport from "react-data-export";
import { IconTypes, BoxIcons } from "us.icons";
import { useTranslation } from "react-i18next";
import { columnDataGenerator } from "./Functions";
import { $Button, $Tooltip } from "../antd";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

/**
 * @description Excel export common component
 * @since 02/16/2024
 */
const ExcelExporter = (props) => {
  const { t } = useTranslation(["US.COLLECTION.COMMON"]);
  const {
    dataSet,
    columns,
    name,
    format,
    disabled,
    className,
    isLabelVisible = true,
  } = props;

  const multiDataSet = [
    {
      columns,
      data: columnDataGenerator(dataSet, columns, format),
    },
  ];

  return (
    <div style={{ pointerEvents: disabled ? "none" : "auto" }}>
      <ExcelFile
        filename={name}
        element={
          <>
            {isLabelVisible && (
              <$Button
                size="small"
                type="link"
                className={className}
                disabled={disabled}
                icon={<BoxIcons type={IconTypes.BOX_ICON} name="excel" />}
              >
                <span className="pl-2">
                  {t("US.COLLECTION.COMMON:COMMON.EXPORTTOEXCELSHEET")}
                </span>
              </$Button>
            )}
            {!isLabelVisible && (
              <$Tooltip
                placement="topLeft"
                disabled={true}
                title={t("US.COLLECTION.COMMON:COMMON.EXPORTTOEXCELSHEET")}
              >
                <$Button
                  size="small"
                  type="link"
                  className={className}
                  disabled={disabled}
                  icon={<BoxIcons type={IconTypes.BOX_ICON} name="excel" />}
                />
              </$Tooltip>
            )}
          </>
        }
      >
        <ExcelSheet dataSet={multiDataSet} name={name}></ExcelSheet>
      </ExcelFile>
    </div>
  );
};

export default ExcelExporter;
